import {UyapRequest} from "./UyapRequest";
import {ISorguSonuc} from "./CommonInterfaces"
import app from "@/main";


export interface DosyaBorcluEgmMahrumiyetTalep {
    dosyaId: string | number,
    kisiKurumId: number,
    plaka: string,          // egm sorgusundaki plakaSifreli gönderilecek
}

export interface DosyaBorcluEgmMahrumiyetCevap extends ISorguSonuc<IDosyaBorcluEgmMahrumiyetSonuc> {

}

export interface IDosyaBorcluEgmMahrumiyetSonuc {
    hataMesaj: string,
    hatakod: number,
    kurumAdi: string,
    kurumTipi: number,
    output: IMahrumiyet,
    sonuc: number
}

export interface IMahrumiyet {
    aciklama: string,
    alacakTutari: number,
    belgeId: string,
    eklemeTarihSaat: string,
    eklemeTarihi: string,
    ekleyenBirim: string,
    ekleyenBirimKodu: string,
    evrakSayisi: string,
    evrakTarihi: string,
    kurumAd: string,
    kurumKodu: number,
    plaka: string,
    referansNo: string,
    takyidatAdi: string,
    takyidatSayisi: number,
    turu: string,
}

export default class DosyaBorcluEgmMahrumiyet extends UyapRequest<DosyaBorcluEgmMahrumiyetTalep, DosyaBorcluEgmMahrumiyetCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "DosyaBorcluEgmMahrumiyet_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2IlQtSHWYcbntjWLnK9uvDSMX0wPNaiyNZFNUdFMPPkW8","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"25/04/2024 13:00","sorguSonucDVO":{"hataMesaj":"İşlem Başarılı","hatakod":0,"sonuc":"-1","output":[{"kurumAd":"Adalet Bakanlığı","turu":"3","ekleyenBirim":"Ankara 11. İcra Dairesi","evrakTarihi":"2/7/2009","evrakSayisi":"2009-7400","eklemeTarihi":"2/7/2009","referansNo":"2009070215473449879","takyidatAdi":"HACİZLİ(H)","belgeId":"12aac635-485e-4ec0-a262-442e2333c499","aciklama":"20090702","alacakTutari":0.0,"plaka":"60DE737                                           ","kurumKodu":2,"takyidatSayisi":3,"ekleyenBirimKodu":"1000949","eklemeTarihSaat":"02.07.2009 15:47:35"},{"kurumAd":"Adalet Bakanlığı","turu":"35","ekleyenBirim":"Ankara 11. İcra Dairesi","evrakTarihi":"2/7/2009","evrakSayisi":"2009-7400","eklemeTarihi":"2/7/2009","referansNo":"2009070215495829172","takyidatAdi":"YAKALAMA","belgeId":"12aac635-485e-4ec0-a262-442e2333c499","aciklama":"20090702","alacakTutari":0.0,"plaka":"60DE737                                           ","kurumKodu":2,"takyidatSayisi":3,"ekleyenBirimKodu":"1000949","eklemeTarihSaat":"02.07.2009 15:49:59"},{"kurumAd":"Adalet Bakanlığı","turu":"36","ekleyenBirim":"Tokat (Sulh Hukuk Mah.) Satış Memurluğu","evrakTarihi":"6/4/2021","evrakSayisi":"2019-12 Satış","eklemeTarihi":"6/4/2021","referansNo":"2021040614463896021","takyidatAdi":"İCRA SATIŞ ŞERHİ","belgeId":"12aac635-485e-4ec0-a262-442e2333c499","aciklama":" Plaka No 60DE737 - İcra Satış Şerhi - Diğer - 02/04/2021 tarihli karar gereği ","alacakTutari":0.0,"plaka":"60DE737                                           ","kurumKodu":2,"takyidatSayisi":3,"ekleyenBirimKodu":"1032896","eklemeTarihSaat":"06.04.2021 14:46:39"}],"kurumAdi":"Türkiye Noterler Birliği","kurumTipi":0},"sorgulamaTuru":"EGM Mahrumiyet Sorgu","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_arac_mahrumiyet_brd.ajx';
    }

    async parse(data: any): Promise<DosyaBorcluEgmMahrumiyetCevap> {
       data.message = data.sorguSonucDVO.hataMesaj;
       return data
    }

}

